<template>
  <modal-base title="Impressum" ref="modal">
    <p>
      <b>Herausgeber</b><br />
      Landratsamt Forchheim<br />
      Am Streckerplatz 3<br />
      91301 Forchheim<br />
      Telefon: 09191 / 86-0<br />
      Fax: 09191 / 86-1448<br />
      E-Mail: poststelle@lra-fo.de<br />
      Web: www.landkreis-forchheim.de
    </p>
    <p>
      <b>Vertretungsberechtigter</b><br />
      Landrat Dr. Hermann Ulm
    </p>
    <p>
      Das Landratsamt Forchheim hat die Rechtsform einer Körperschaft des
      Öffentlichen Rechts. Zuständige Aufsichtsbehörde ist die Regierung von
      Oberfranken. Umsatzsteuer – Identifikationsnummer gemäß § 27 a
      Umsatzsteuergesetz: DE 132507936
    </p>
    <p>
      <b>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</b> Frau Bärbel
      Matiaske<br />
      Am Streckerplatz 3<br />
      91301 Forchheim<br />
      Telefon: 09191 / 86-3510<br />
      Fax: 09191 / 86-883510<br />
      E-Mail: hebammeforchheim@lra-fo.de
    </p>
    <b>Programmierung des Vermittlungsportals:</b>
    <a href="https://www.hmr-it.de">
      <b-img style="height: 100px" :src="require('../../assets/hmr-logo.png')" />
    </a>
    <p>
      HMR-IT GmbH<br />
      Dietzhof 2<br />
      91359 Leutenbach<br />
    </p>

    <p>
      <b>Nutzungsbedingungen</b><br />
      Texte, Bilder, Grafiken sowie die Gestaltung dieses Vermittlungsportals
      unterliegt dem Urheberrecht. Sie dürfen von Ihnen nur zum privaten und
      sonstigen eigenen Gebrauch im Rahmen des § 53 Urheberrechtsgesetz (UrhG)
      verwendet werden. Eine Vervielfältigung oder Verwendung dieser Seiten
      oder Teilen davon in anderen elektronischen oder gedruckten
      Publikationen und deren Veröffentlichung ist nur mit unserer
      Einwilligung gestattet. Diese erteilen auf Anfrage die für den Inhalt
      Verantwortlichen. Weiterhin können Texte, Bilder, Grafiken und sonstige
      Dateien ganz oder teilweise dem Urheberrecht Dritter unterliegen. Auch
      über das Bestehen möglicher Rechte Dritter geben Ihnen die für den
      Inhalt Verantwortlichen nähere Auskünfte.
    </p>
    <p>
      <b>Haftungsausschluss</b><br />
      Alle auf dieser Internetseite bereitgestellten Informationen haben wir
      nach bestem Wissen und Gewissen erarbeitet und geprüft. Eine Gewähr für
      die jederzeitige Aktualität, Richtigkeit, Vollständigkeit und
      Verfügbarkeit der bereit gestellten Informationen können wir allerdings
      nicht übernehmen. Ein Vertragsverhältnis mit den Nutzern des
      Vermittlungsportals kommt nicht zustande. Wir haften nicht für Schäden,
      die durch die Nutzung dieses Internetangebots entstehen. Dieser
      Haftungsausschluss gilt nicht, soweit die Vorschriften des § 839 BGB
      (Haftung bei Amtspflichtverletzung) einschlägig sind. Für etwaige
      Schäden, die beim Aufrufen oder Herunterladen von Daten durch
      Schadsoftware oder der Installation oder Nutzung von Software verursacht
      werden, wird nicht gehaftet. Das Landratsamt Forchheim behält sich
      ausdrücklich vor, einzelne Webseiten oder das gesamte Angebot ohne
      gesonderte Ankündigung zu verändern, zu ergänzen, zu löschen oder die
      Veröffentlichung zeitweise oder endgültig einzustellen.
    </p>
    <p>
      <b>Querverweise - Links</b><br />
      Von unseren eigenen Inhalten sind Querverweise („Links“) auf die
      Webseiten anderer Anbieter zu unterscheiden. Durch diese Links
      ermöglichen wir lediglich den Zugang zur Nutzung fremder Inhalte nach §
      8 Telemediengesetz. Bei der erstmaligen Verknüpfung mit diesen
      Internetangeboten haben wir diese fremden Inhalte daraufhin überprüft,
      ob durch sie eine mögliche zivilrechtliche oder strafrechtliche
      Verantwortlichkeit ausgelöst wird. Wir können diese fremden Inhalte aber
      nicht ständig auf Veränderungen überprüfen und daher auch keine
      Verantwortung dafür übernehmen. Für illegale, fehlerhafte oder
      unvollständige Inhalte und insbesondere für Schäden, die aus der Nutzung
      oder Nichtnutzung von Informationen Dritter entstehen, haftet allein der
      jeweilige Anbieter der Seite.
    </p>
  </modal-base>
</template>

<script>
import ModalBase from "./ModalBase";
import { modalBaseMixin } from "../../mixins/modalBase";

export default {
  name: "ImpressumModal",
  components: { ModalBase },
  mixins: [modalBaseMixin]
};
</script>

<style scoped></style>
